import { forwardRef, type Ref, type SVGProps } from "react";

function SvgCalendarRemove(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M6.235 3.667V2m7.28 1.667V2M7.649 8.042l4.45 4.584m.002-4.584-4.45 4.584M5.426 17h8.897c1.34 0 2.427-1.12 2.427-2.5V6.167c0-1.381-1.086-2.5-2.427-2.5H5.426C4.086 3.667 3 4.786 3 6.167V14.5C3 15.88 4.086 17 5.426 17"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgCalendarRemove);
export default ForwardRef;
